// extracted by css-extract-rspack-plugin
export default {"label_override":"xf_4D","labelOverride":"xf_4D","#":"bdwmL"};